import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import "./Cards.css";
import Map from "./Map";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

const Cards = () => {
  const [cardData, setCardData] = useState([
    { id: 1, title: "Benefits Unlocked", value: 0, suffix: "crore+" },
    { id: 2, title: "Citizens Reached", value: 0, suffix: "million+" },
    { id: 3, title: "Applications Facilitated", value: 0, suffix: "million+" },
    { id: 4, title: "Individuals trained on digital and financial literacy since April’23", value: 0, suffix: "lakh+" },
    { id: 5, title: "Haqdarshaks trained & provided income earning opportunities", value: 0, suffix: "+" },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responses = await Promise.all([
          fetch(`${API_BASE_URL}/api/benefit-unlocked`),
          fetch(`${API_BASE_URL}/api/citizen-reached`),
          fetch(`${API_BASE_URL}/api/application-facilated`),
          fetch(`${API_BASE_URL}/api/dfl-trained`),
          fetch(`${API_BASE_URL}/api/Haqdarshak-trained`),
        ]);

        const data = await Promise.all(responses.map(res => res.json()));

        const updatedData = [
          {
            id: 1,
            title: "Benefits Unlocked",
            value: (data[0][0]["Number of Benefit unlocked"] / 1e7).toFixed(2), // crore
            suffix: "crore+"
          },
          {
            id: 2,
            title: "Citizens Reached",
            value: (data[1][0]["Number of Citizens reached"] / 1e6).toFixed(2), // million
            suffix: "million+"
          },
          {
            id: 3,
            title: "Applications Facilitated",
            value: (data[2][0]["Number of Application facilated"] / 1e6).toFixed(2), // million
            suffix: "million+"
          },
          {
            id: 4,
            title: "Individuals trained on digital and financial literacy since April’23",
            value: (data[3][0]["Number of DFL Trained"] / 1e5).toFixed(2), // lakh
            suffix: "lakh+"
          },
          {
            id: 5,
            title: "Haqdarshaks trained & provided income earning opportunities",
            value: data[4][0]["Number of Haqdarshaks Trained"],
            suffix: "+"
          }
        ];

        setCardData(updatedData);
      } catch (error) {
        console.error("Error fetching card data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="cards-wrapper">
      <div className="cards-container-vertical">
      {cardData.map((card) => (
  <div key={card.id} className="card">
    <h2 className="impact-title">
      <CountUp
        start={0}
        end={parseFloat(card.value)}
        duration={2}
        decimals={card.id === 5 ? 0 : (card.value < 1 ? 3 : 2)} // No decimals for HD trained
      />{" "}
      {card.suffix}
    </h2>
    <p>{card.title}</p>
  </div>
))}
      </div>
      <div className="cards-image-container">
        <Map />
      </div>
    </div>
  );
};

export default Cards;




//Cards with manual values
// import React from "react";
// import CountUp from "react-countup";
// import "./Cards.css";
// import Map from "./Map"; // Adjust the path if Map.js is in a different folder

// const Cards = () => {
//   const cardData = [
//     { id: 1, title: "Benefits Unlocked", value: 19860, unit: "", suffix: "crore+" },
//     { id: 2, title: "Citizens Reached", value: 7, unit: "", suffix: "million+" },
//     { id: 3, title: "Applications Facilitated", value: 6.84, unit: "", suffix: "million+" },
//     { id: 4, title: "Individuals trained on digital and financial literacy since April’23", value: 12.02, unit: "", suffix: "lakh+" },
//     { id: 5, title: "Haqdarshaks trained & provided income earning opportunities", value: 47118, unit: "", suffix: "+" },
//   ];

//   return (
//     <div className="cards-wrapper">
//       <div className="cards-container-vertical">
//         {cardData.map((card) => (
//           <div key={card.id} className="card">
//             <h2 className="impact-title">
//               {card.unit}{" "}
//               <CountUp start={0} end={card.value} duration={2} decimals={card.value < 1 ? 3 : 2} />{" "}
//               {card.suffix}
//             </h2>
//             <p>{card.title}</p>
//           </div>
//         ))}
//       </div>
//       <div className="cards-image-container">
//         <Map /> {/* Render the Map component instead of an image */}
//       </div>
//     </div>
//   );
// };

// export default Cards;






//Cards with image used
// import React from "react";
// import CountUp from "react-countup";
// import "./Cards.css";

// const Cards = () => {
//   const cardData = [
//     { id: 1, title: "Benefits Unlocked", value: 19860, unit: "", suffix: "crore+" },
//     { id: 2, title: "Citizens Reached", value: 7, unit: "", suffix: "million+" },
//     { id: 3, title: "Applications Facilitated", value: 6.84, unit: "", suffix: "million+" },
//     { id: 4, title: "Individuals trained on digital and financial literacy since April’23", value: 12.02, unit: "", suffix: "lakh+" },
//     { id: 5, title: "Haqdarshaks trained & provided income earning opportunities", value: 47118, unit: "", suffix: "+" },
//   ];

//   return (
//     <div className="cards-wrapper">
//       <div className="cards-container-vertical">
//         {cardData.map((card) => (
//           <div key={card.id} className="card">
//             <h2 className="impact-title">
//               {card.unit}{" "}
//               <CountUp start={0} end={card.value} duration={2} decimals={card.value < 1 ? 3 : 2} />{" "}
//               {card.suffix}
//             </h2>
//             <p>{card.title}</p>
//           </div>
//         ))}
//       </div>
//       <div className="cards-image-container">
//         <img src="/map5.png" alt="Impact" className="cards-image" />
//       </div>
//     </div>
//   );
// };

// export default Cards;
